module.exports = __webpack_public_path__ + "static/media/olake-product-meta.0769fb60.png";